import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { Device } from '../models/device';
import { store } from './store';

export default class DeviceMaster {
  deviceRegistry = new Map<string, Device>();
  selectedDevice: Device | undefined = undefined;
  loadingInitial = false;
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }
  get deviceitemsByDate() {
    return Array.from(this.deviceRegistry.values());
  }
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  private setDevice = (Device: Device) => {
    this.deviceRegistry.set(Device.id, Device);
  };

  private getDevice = (id: string) => {
    return this.deviceRegistry.get(id);
  };

  loadDevices = async () => {
    this.loadingInitial = true;
    try {
      const deviceDetails = await agent.Devices.list();
      // console.log(recievingdelivery);
      deviceDetails.forEach((deviceDetails) => {
        runInAction(() => {
          this.setDevice(deviceDetails);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  loadDevice = async (id: string) => {
    const DeviceDetail = this.getDevice(id);
    if (DeviceDetail) {
      this.selectedDevice = DeviceDetail;
      return DeviceDetail;
    } else {
      this.loadingInitial = true;
      try {
        const Device = await agent.Devices.details(id);
        this.setDevice(Device);
        runInAction(() => {
          this.selectedDevice = Device;
        });
        this.setLoadingInitial(false);
        return Device;
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
      }
    }
  };

  createDevice = async (device: any) => {
    try {
      await agent.Vaults.UpdateDeviceNew(device);
      runInAction(() => {
        store.vaultStore.vaultRegistry.set(device.id, device);
      });
      toast.success('Device Record Created Successfully ');
    } catch (error) {
      console.log(error);
    }
  };
  updateDevice = async (Device: Device) => {
    this.loading = true;

    try {
      await agent.Devices.update(Device);
      runInAction(() => {
        this.deviceRegistry.set(Device.id, Device);
        this.selectedDevice = Device;
        // this.editMode = false;
        this.loading = false;
      });
      toast.success('Device  Updated Succesfully.');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  deleteDevice = async (Device: Device) => {
    try {
      await agent.Devices.delete(Device);
      runInAction(() => {
        this.deviceRegistry.delete(Device.id);
      });
      toast.success('Device Deleted Succesfully.');
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    }
  };
}
